import "./AddCourse.css";
import React, { Fragment } from "react";
import AddCourseViewModel from "./AddCourseViewModel";
import ReactSelect from "../../../../Components/Select/React-Select";
const AddCourse = () => {
  const {
    RegisterCourse,
    FormDisabled,
    AddCourse,
    setAddCourse,
    CourseIDError,
    CourseNameError,
    TeacherError,
    IsUpdate,
    TeachersArray,
    setTeacherID,
    TotalClassesInWeekError,
    setTotalClassesInWeekError,
  } = AddCourseViewModel();

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-course">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Add Course</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Class And Courses</a>
                  </li>
                  <li className="breadcrumb-item active">Add Course</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <h5 className="form-title">
                          <span>Course Information</span>
                        </h5>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Course Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              CourseNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddCourse({
                                ...AddCourse,
                                CourseName: e.target.value,
                              });
                            }}
                            value={AddCourse.CourseName}
                            disabled={FormDisabled}
                          />
                          {CourseNameError === true ? (
                            <span className="admin-add-course-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Course name is required and can not be less than
                                3 characters
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-course-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Course name is required and can not be less than
                                3 characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Course ID <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              CourseIDError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddCourse({
                                ...AddCourse,
                                CourseID: e.target.value,
                              });
                            }}
                            value={AddCourse.CourseID}
                            disabled={FormDisabled}
                          />
                          {CourseIDError === true ? (
                            <span className="admin-add-course-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Course is required
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-course-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Course is required
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Teacher <span className="login-danger">*</span>
                          </label>
                          <ReactSelect
                            disabled={FormDisabled}
                            error={TeacherError === true ? true : false}
                            handleChange={(val) => {
                              setTeacherID(val);
                            }}
                            options={[
                              {
                                value: "select teacher",
                                label: "Please select teacher",
                                isDisabled: true,
                              },
                              ...TeachersArray?.map((item) => ({
                                value: item.id,
                                label: item.FirstName + item.LastName,
                              })),
                            ]}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Weekly Classes
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              TotalClassesInWeekError === true &&
                              "error-message"
                            }`}
                            type="number"
                            onChange={(e) => {
                              console.log(e.target.value);
                              setAddCourse({
                                ...AddCourse,
                                TotalClassesInWeek: e.target.value,
                              });
                            }}
                            value={AddCourse.TotalClassesInWeek}
                            disabled={FormDisabled}
                          />
                          {TotalClassesInWeekError === true ? (
                            <span className="admin-add-course-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Total classes in one week is required
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-course-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Total Number of classes in one week
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="student-submit">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              RegisterCourse();
                            }}
                            disabled={FormDisabled}
                          >
                            {IsUpdate ? "Update" : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddCourse;
